// extracted by mini-css-extract-plugin
export default {"Bprivacy":"airAgreement_Bprivacy__rCQGp","pt18":"airAgreement_pt18__eLeFR","pt12":"airAgreement_pt12__XW5yx","pt135":"airAgreement_pt135__vNPmz","list":"airAgreement_list__MXw+w"};